export default {
  meta: {
    title: '客流服务详情',
  }
};
